import { css } from 'linaria';

export const cartButton = css`
  margin-top: auto;
  background-color: var(--control-primary) !important;

  &:hover {
    background-color: var(--control_hover-primary) !important;
  }
`;

export const imageBaseWrapper = css`
  position: relative;
  flex-shrink: 0;
  width: 132px;
  height: 132px;

  @media (--to-desktop) {
    width: 104px;
    height: 104px;
  }
`;

export const simplifiedImageWrapper = css`
  position: relative;
  flex-shrink: 0;
  width: 80px;
  height: 80px;

  @media (--to-desktop) {
    width: 120px;
    height: 120px;
  }

  @media (--only-mobile) {
    width: 104px;
    height: 104px;
  }
`;

export const productBaseWrapper = css`
  display: flex;
  gap: var(--space-125);
  width: 375px;
  height: 100%;
  padding: var(--space-150);
  background-color: var(--background-primary);
  border-radius: var(--rounding-m);

  @media (--only-tablet) {
    flex-direction: column;
    width: 144px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    width: 128px;
  }
`;

export const productBaseWrapperSimplified = css`
  display: flex;
  gap: var(--space-125);
  width: 280px;
  height: 100%;
  padding: var(--space-150);
  background-color: var(--background-primary);
  border-radius: var(--rounding-m);

  @media (--only-tablet) {
    flex-direction: column;
    width: 144px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    width: 128px;
  }
`;

export const contentBaseWrapper = css`
  width: 100%;

  &.list {
    margin-left: var(--space-250);

    @media (--only-tablet) {
      margin-left: var(--space-200);
    }
  }

  @media (--only-mobile) {
    &,
    &.large-card,
    &.list {
      margin: var(--space-125) 0 0;
    }
  }
`;
